// Today screen -> chat: a photo just taken or "start the mic", picked up once when the chat opens.
let pending = null
export function setHandoff(x) { pending = x }
export function takeHandoff() { const p = pending; pending = null; return p }
